import { isPolicyArtifactUnavailableError } from "@/api/trainingPolicies";
import {
  isTrainingShareLinkNotConfiguredError,
  isTrainingShareLinkNotFoundError,
} from "@/api/trainingShareLinks";
import { isHttpClientError } from "@/http";

// 공유 링크 발급·다시 발급·폐기 실패 문구의 단일 소유자. 공유 버튼이 네 표면(Policy 행·Exported·
// Raw·공유 링크 탭)에 있다. 같은 실패가 화면마다 다른 말로 표시되지 않게 한다.

export const SHARE_LINK_COPIED_MESSAGE =
  "공유 링크를 복사했습니다. 링크는 1일 동안 열 수 있습니다.";

export function shareLinkIssueErrorMessage(error: unknown): string {
  if (isPolicyArtifactUnavailableError(error)) {
    return "이 Policy는 공유할 수 없습니다. 파일이 Training 산출물 저장 위치 밖에 있거나 더 이상 남아 있지 않습니다.";
  }
  if (isTrainingShareLinkNotConfiguredError(error)) {
    return "이 서버에서는 공유 링크를 만들 수 없습니다. 관리자에게 문의해 주세요.";
  }
  // 대상 부재·스코프 밖 코드는 셋(Policy·세션·Raw)이다. 그래서 404 하나로 받는다. 권한으로 문구를
  // 나누지 않는다. BE 는 존재 여부를 노출하지 않으려고 같은 404 를 준다.
  if (
    isTrainingShareLinkNotFoundError(error) ||
    (isHttpClientError(error) && error.status === 404)
  ) {
    return "공유할 대상을 찾을 수 없습니다. 목록을 새로고침한 뒤 다시 시도해 주세요.";
  }
  return "공유 링크를 만들지 못했습니다. 잠시 후 다시 시도해 주세요.";
}

export function shareLinkRevokeErrorMessage(error: unknown): string {
  if (isTrainingShareLinkNotFoundError(error)) {
    return "이미 폐기된 링크입니다. 목록을 새로고침해 주세요.";
  }
  return "공유 링크를 폐기하지 못했습니다. 잠시 후 다시 시도해 주세요.";
}
